import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center" }

import {
  computed, defineAsyncComponent, PropType, ref,
} from 'vue';
import { ActionParams, FieldContent } from '@/components/TableComponent/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomButton',
  props: {
  value: {
    type: Object as PropType<FieldContent>,
    default: () => {},
  },
  actionParams: {
    type: Object as PropType<ActionParams>,
    default: () => {},
  },
},
  emits: ['action'],
  setup(__props, { emit }) {

const props = __props



const action = ref(props.value.action);

const isMenuAnchor = computed(() => props.value.action.type === 'menu');
const menuComponent = defineAsyncComponent(() => import(`~components/menus/${props.value.action.name}.vue`));



const clickHandler = () => {
  const params = {
    name: action.value.name,
    type: action.value.type,
    customParam: props.actionParams,
  };
  emit('action', params);
};


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_btn, {
      flat: "",
      color: "accent",
      class: "q-pa-none",
      onClick: _withModifiers(clickHandler, ["stop"])
    }, {
      default: _withCtx(() => [
        (__props.value?.icon)
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 0,
              name: __props.value?.icon
            }, null, 8, ["name"]))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(__props.value?.text) + " ", 1),
        (_unref(isMenuAnchor))
          ? (_openBlock(), _createBlock(_component_q_menu, { key: 1 }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(menuComponent)), {
                  params: props.actionParams
                }, null, 8, ["params"]))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}
}

})